import * as React from 'react';
import * as ReactDOM from 'react-dom';

import 'semantic-ui-css/semantic.min.css';
import './index.css';

import App from './app/App';

ReactDOM.render(
  <App />,
  document.getElementById('root') as HTMLElement
);
